import React, { Component } from 'react';
import { authFormChange, loginB24 } from '../../actions/authActions';
import { connect } from 'react-redux';
import * as EmailValidator from 'email-validator';

import { Form, Icon, Input, Button, Row, Col, Divider } from 'antd';
const FormItem = Form.Item;

class Login extends Component {
    updateSubmission(event){
        let updatedSubmission = Object.assign({}, this.props.auth_form);
        updatedSubmission[event.target.id] = event.target.value;
        this.props.authFormChange(updatedSubmission);
    }

    submitSubmission(){
        this.props.loginB24(this.props.auth_form); 
    }  

    hasErrors(){
        if(!this.props.auth_form.login)
            return true;

        if(!this.props.auth_form.password)
            return true;            
    }

    render(){
        return (
            <Row>
                <Col span={4}></Col>
                <Col span={16} style={{ textAlign: 'center' }}>
                    <Form layout="inline" className="login-form" >
                        <FormItem>
                            <Input id="login" name="login" style={{ width: '200px' }}  prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} type="text" placeholder="Username" value={this.props.auth_form.login} onChange={this.updateSubmission.bind(this)} />
                        </FormItem>
                        <FormItem>
                            <Input id="password" name="password" style={{ width: '200px' }}  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" value={this.props.auth_form.password} onChange={this.updateSubmission.bind(this)} />
                        </FormItem>
                        <FormItem>
                        <Button  disabled={this.hasErrors()} type="primary" htmlType="submit" onClick={this.submitSubmission.bind(this)} className="login-form-button">
                            вход
                        </Button>
                        </FormItem>
                    </Form>                   
                    <br />
                </Col>
                <Col span={4}></Col>
            </Row>
        )
    }
}

const mapStateToProps = state => ({
    auth_form: state.auth.auth_form,
    auth: state.auth
})

const mapDispatchToProps = dispatch => ({
    authFormChange: payload => dispatch(authFormChange(payload)),
    loginB24: payload => dispatch(loginB24(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/presentation/Login.js